export default __webpack_public_path__ + "static/media/1wash-card.3544f46a.png";